const CONSULTATIONS_LIMIT = 10
const RECORDING_TIME_LIMIT = 18000 // 5 horas em segundos

const CUSTOM_PROMPTS_LIMITS = {
  editedDaai: 1,
  freeText: 1,
  aiGenerated: 1,
  tabs: 3,
}

const CUSTOM_PROMPT_CATEGORIES = ['editedDaai', 'freeText', 'aiGenerated']

const MAX_FREE_CUSTOM_PROMPTS_TOTAL =
  CUSTOM_PROMPTS_LIMITS.editedDaai +
  CUSTOM_PROMPTS_LIMITS.freeText +
  CUSTOM_PROMPTS_LIMITS.aiGenerated

const CONSUMPTION_THRESHOLDS = [
  { id: 'state1', minConsultations: 3, minRecordingSeconds: 5400 }, // 1h30
  { id: 'state2', minConsultations: 5, minRecordingSeconds: 9000 }, // 2h30
  { id: 'state3', minConsultations: 7, minRecordingSeconds: 14400 }, // 4h
  { id: 'state4', minConsultations: 9, minRecordingSeconds: 16200 }, // 4h30
]

export {
  CONSULTATIONS_LIMIT,
  RECORDING_TIME_LIMIT,
  CUSTOM_PROMPTS_LIMITS,
  CUSTOM_PROMPT_CATEGORIES,
  MAX_FREE_CUSTOM_PROMPTS_TOTAL,
  CONSUMPTION_THRESHOLDS,
}
